import React from 'react';
import { getSystemSettings } from "../../../../functions/Functions";

const RcrReportTemplate = React.forwardRef(({ reportData, generalSettings }, ref) => {
  return (
    <div className="mt-2 overflow-x-auto" ref={ref} style={{ fontSize: '13.3px' }}>
      <div className="card border-0 shadow-sm rounded-lg overflow-hidden">
        <table className="table table-bordered table-sm mb-0" id="table-to-xls" style={{ borderCollapse: 'collapse', width: '100%' }}>
          <thead>
            <tr>
              <th colSpan="5" className="text-center px-3 py-2 font-weight-bold" style={{ backgroundColor: '#1e293b', color: '#ffffff', fontSize: '18px', letterSpacing: '1px' }} bgcolor="#1e293b">
                {parseInt(getSystemSettings(generalSettings, "print_logo")) === 1 && (
                  <img 
                    src={`${getSystemSettings(generalSettings, "type_logo")}`} 
                    alt="logo" 
                    className="rounded-circle"
                    style={{ height: '38px', float: 'left', marginRight: '15px' }} 
                  />
                )}
                <span style={{ lineHeight: '30px' }}>RESTAURANT COMPLIANCE REPORT (RCR)</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {/* Audit Data Section */}
            <tr>
              <td colSpan="5" className="font-weight-bold py-2 text-uppercase" style={{ fontSize: '12px', backgroundColor: '#f1f5f9', color: '#1e293b', borderBottom: '2px solid #e2e8f0' }} bgcolor="#f1f5f9">
                AUDIT DATA
              </td>
            </tr>
            <tr>
              <td className="py-2 font-weight-bold text-dark" style={{width: '20%'}}>Outlet / Venue:</td>
              <td className="py-2 font-weight-bold" style={{width: '25%', color: '#0f172a'}}>{reportData?.audit_data?.outlet}</td>
              <td className="py-2" style={{width: '25%'}}></td>
              <td className="py-2 font-weight-bold text-dark" style={{width: '15%'}}>Auditor:</td>
              <td className="py-2 font-weight-bold" style={{width: '15%', color: '#0f172a'}}>{reportData?.audit_data?.auditor}</td>
            </tr>
            <tr>
              <td className="py-2 font-weight-bold text-dark">Date:</td>
              <td className="py-2 font-weight-bold" style={{ color: '#0f172a' }}>{reportData?.audit_data?.date}</td>
              <td className="py-2 text-dark font-weight-bold">Audit ID: <span style={{ color: '#0f172a' }}>{reportData?.audit_data?.audit_id}</span></td>
              <td className="py-2 font-weight-bold text-dark">Time:</td>
              <td className="py-2 font-weight-bold" style={{ color: '#0f172a' }}>{reportData?.audit_data?.time}</td>
            </tr>
            <tr>
              <td className="py-2 font-weight-bold text-dark">Audit Scope:</td>
              <td colSpan="2" className="py-2 font-weight-bold" style={{ color: '#0f172a' }}>{reportData?.audit_data?.audit_scope || "Full Scope"}</td>
              <td className="py-2 font-weight-bold text-dark">Auditee:</td>
              <td className="py-2 font-weight-bold" style={{ color: '#0f172a' }}>{reportData?.audit_data?.auditee}</td>
            </tr>
            
            <tr><td colSpan="5" style={{height: '15px', border: 'none', backgroundColor: '#ffffff'}}></td></tr>

            {/* Overall Result Section */}
            <tr className="text-center font-weight-bold text-uppercase" style={{fontSize: "12px", backgroundColor: '#f8fafc', color: '#0f172a'}} bgcolor="#f8fafc">
              <td className="py-2" style={{ borderTop: '2px solid #e2e8f0' }}>OVERALL WEIGHTED SCORE</td>
              <td colSpan="2" className="py-2" style={{ borderTop: '2px solid #e2e8f0' }}>AUDIT RESULT</td>
              <td className="py-2" style={{ borderTop: '2px solid #e2e8f0' }}>CRITICAL GATE STATUS</td>
              <td className="py-2" style={{ borderTop: '2px solid #e2e8f0' }}>SECTIONS AUDITED</td>
            </tr>
            <tr className="text-center align-middle" style={{ backgroundColor: '#ffffff' }}>
              <td className="py-2">
                <h4 className="m-0 font-weight-bold" style={{ color: '#0f172a', fontSize: '18px' }}>{reportData?.overall_summary?.overall_weighted_score}</h4>
              </td>
              <td colSpan="2" className="py-2">
                <h5 className={`m-0 font-weight-bold ${(reportData?.overall_summary?.audit_result || "").includes("FAIL") ? "text-danger" : "text-success"}`} style={{ fontSize: '16px', color: (reportData?.overall_summary?.audit_result || "").includes("FAIL") ? "#dc3545" : "#28a745" }}>
                  {reportData?.overall_summary?.audit_result}
                </h5>
              </td>
              <td className="py-2">
                <h5 className={`m-0 font-weight-bold ${reportData?.overall_summary?.critical_gate_status === "CLEARED" ? "text-success" : "text-danger"}`} style={{ fontSize: '16px', color: reportData?.overall_summary?.critical_gate_status === "CLEARED" ? "#28a745" : "#dc3545" }}>
                  {reportData?.overall_summary?.critical_gate_status === "NOT CLEARED" ? <><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#dc3545" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign: 'middle', marginRight: '4px'}}><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg> NOT CLEARED</> : <><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#28a745" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign: 'middle', marginRight: '4px'}}><polyline points="20 6 9 17 4 12"></polyline></svg> CLEARED</>}
                </h5>
              </td>
              <td className="py-2">
                <h5 className="m-0 text-warning font-weight-bold" style={{ fontSize: '18px' }}>{reportData?.overall_summary?.sections_audited}</h5>
              </td>
            </tr>

            <tr><td colSpan="5" style={{height: '15px', border: 'none', backgroundColor: '#ffffff'}}></td></tr>

            {/* Weighted Scorecard Section */}
            <tr className="text-white font-weight-bold text-center text-uppercase" style={{ backgroundColor: '#334155', color: '#ffffff' }} bgcolor="#334155">
              <td colSpan="5" className="text-left py-2 px-3" style={{ color: '#ffffff', letterSpacing: '0.5px' }}><font color="#ffffff"><b>WEIGHTED SCORECARD</b></font></td>
            </tr>
            <tr className="font-weight-bold text-center" style={{ backgroundColor: '#f1f5f9', color: '#1e293b', fontSize: '12px' }} bgcolor="#f1f5f9">
              <td className="py-2 px-3 text-left border-0"><b>Category</b></td>
              <td className="py-2 border-0"><b>Weightage</b></td>
              <td className="py-2 border-0"><b>Score %</b></td>
              <td className="py-2 border-0"><b>Weighted Score</b></td>
              <td className="py-2 border-0"><b>RAG</b></td>
            </tr>
            {reportData?.weighted_scorecard?.map((item, index) => {
              const isTotal = item.category.toUpperCase().includes("TOTAL");
              if (isTotal) {
                return (
                  <tr key={index} className="text-white font-weight-bold text-center text-uppercase" style={{ backgroundColor: '#334155', color: '#ffffff', fontSize: '13px' }} bgcolor="#334155">
                    <td className="text-left py-3 px-3 border-0" style={{ color: '#ffffff' }}><font color="#ffffff">{item.category}</font></td>
                    <td className="py-3 border-0" style={{ color: '#ffffff' }}><font color="#ffffff">{item.weightage}</font></td>
                    <td className="py-3 border-0" style={{ color: '#ffffff' }}></td>
                    <td className="py-3 border-0" style={{ color: '#ffffff' }}><font color="#ffffff">{item.weighted_score}</font></td>
                    <td className="py-3 border-0" style={{ color: '#ffffff' }}></td>
                  </tr>
                );
              }
              return (
                <tr key={index} className="text-center" style={{ backgroundColor: '#ffffff' }}>
                  <td className="text-left py-2 px-3 font-weight-bold" style={{ fontSize: '13px', color: '#0f172a' }}>{item.category}</td>
                  <td className="py-2 font-weight-bold" style={{ fontSize: '13px', color: '#0f172a' }}>{item.weightage}</td>
                  <td className={`py-2 font-weight-bold`} style={{ fontSize: '13px', backgroundColor: item.rag === "Red" ? '#fee2e2' : item.rag === "Amber" ? '#fef3c7' : '#dcfce7', color: item.rag === "Red" ? '#991b1b' : item.rag === "Amber" ? '#92400e' : '#166534' }} bgcolor={item.rag === "Red" ? '#fee2e2' : item.rag === "Amber" ? '#fef3c7' : '#dcfce7'}>{item.score_percent}</td>
                  <td className="py-2 font-weight-bold" style={{ fontSize: '13px', color: '#0f172a' }}>{item.weighted_score}</td>
                  <td className="py-2 font-weight-bold" style={{ fontSize: '13px' }}>
                    <span className="px-2 py-1 rounded" style={{ display: 'inline-flex', alignItems: 'center', backgroundColor: item.rag === "Red" ? '#fef2f2' : item.rag === "Amber" ? '#fffbeb' : '#f0fdf4', color: item.rag === "Red" ? "#dc2626" : item.rag === "Amber" ? "#d97706" : "#16a34a" }}>
                      <span style={{ display: 'inline-block', width: '10px', height: '10px', borderRadius: '50%', backgroundColor: item.rag === "Red" ? "#dc2626" : item.rag === "Amber" ? "#d97706" : "#16a34a", marginRight: '5px' }}></span> {item.rag}
                    </span>
                  </td>
                </tr>
              );
            })}

            <tr><td colSpan="5" style={{height: '15px', border: 'none', backgroundColor: '#ffffff'}}></td></tr>

            {/* Critical Compliance Gates Section */}
            <tr className="font-weight-bold text-white text-uppercase" style={{ backgroundColor: '#991b1b', color: '#ffffff' }} bgcolor="#991b1b">
              <td colSpan="5" className="py-2 px-3 text-left" style={{ fontSize: '12px', letterSpacing: '0.5px', color: '#ffffff' }}><font color="#ffffff"><b>CRITICAL COMPLIANCE GATES <span style={{opacity: 0.8, textTransform: 'none'}}>(zero-tolerance - not weighted, override result)</span></b></font></td>
            </tr>
            <tr className="font-weight-bold text-center text-white" style={{ backgroundColor: '#1e293b', color: '#ffffff', fontSize: '12px' }} bgcolor="#1e293b">
              <td colSpan="2" className="py-2 px-3 text-left border-0"><font color="#ffffff"><b>Gate</b></font></td>
              <td className="py-2 border-0"><font color="#ffffff"><b>Score %</b></font></td>
              <td className="py-2 border-0"><font color="#ffffff"><b>Critical NCs</b></font></td>
              <td className="py-2 border-0"><font color="#ffffff"><b>Status</b></font></td>
            </tr>
            {reportData?.critical_gates?.map((item, index) => (
              <tr key={index} className="text-center" style={{ backgroundColor: '#ffffff' }}>
                <td colSpan="2" className="text-left py-2 px-3 font-weight-bold" style={{ fontSize: '13px', color: '#0f172a' }}>{item.gate}</td>
                <td className="py-2 font-weight-bold" style={{ fontSize: '13px', color: '#0f172a' }}>{item.score_percent}</td>
                <td className="py-2 font-weight-bold" style={{ fontSize: '13px', color: '#0f172a' }}>{item.critical_ncs}</td>
                <td className="py-2 font-weight-bold" style={{ fontSize: '13px', backgroundColor: item.status === "FAIL" ? "#fee2e2" : "#dcfce7", color: item.status === "FAIL" ? "#b91c1c" : "#15803d" }} bgcolor={item.status === "FAIL" ? "#fee2e2" : "#dcfce7"}>
                  {item.status === "FAIL" ? <><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#b91c1c" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign: 'middle', marginRight: '4px'}}><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg> FAIL</> : <><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#15803d" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign: 'middle', marginRight: '4px'}}><polyline points="20 6 9 17 4 12"></polyline></svg> PASS</>}
                </td>
              </tr>
            ))}

            <tr><td colSpan="5" style={{height: '15px', border: 'none', backgroundColor: '#ffffff'}}></td></tr>

            <tr>
              <td colSpan="5" className="font-weight-bold py-2 px-3 text-uppercase" style={{ fontSize: '12px', backgroundColor: '#f1f5f9', color: '#1e293b', borderBottom: '2px solid #e2e8f0' }} bgcolor="#f1f5f9">Audit Observations</td>
            </tr>
            <tr>
              <td colSpan="5" className="py-3 px-3 font-weight-bold" style={{ minHeight: '40px', color: '#0f172a', backgroundColor: '#ffffff' }}>{reportData?.qualitative?.audit_features || "None"}</td>
            </tr>
            <tr><td colSpan="5" style={{height: '15px', border: 'none', backgroundColor: '#ffffff'}}></td></tr>
            
            <tr>
              <td colSpan="5" className="font-weight-bold py-2 px-3 text-uppercase" style={{ fontSize: '12px', backgroundColor: '#f1f5f9', color: '#1e293b', borderBottom: '2px solid #e2e8f0' }} bgcolor="#f1f5f9">Audit Exceptions</td>
            </tr>
            <tr>
              <td colSpan="5" className="py-3 px-3 font-weight-bold" style={{ minHeight: '40px', color: '#0f172a', backgroundColor: '#ffffff' }}>{reportData?.qualitative?.exceptions || "None"}</td>
            </tr>
            <tr><td colSpan="5" style={{height: '15px', border: 'none', backgroundColor: '#ffffff'}}></td></tr>

            <tr>
              <td colSpan="5" className="font-weight-bold py-2 px-3 text-uppercase" style={{ fontSize: '12px', backgroundColor: '#f1f5f9', color: '#1e293b', borderBottom: '2px solid #e2e8f0' }} bgcolor="#f1f5f9">Audit Observations - Appreciations, Issues & Call for Improvement</td>
            </tr>
            <tr>
              <td colSpan="5" className="py-3 px-3 font-weight-bold" style={{ minHeight: '60px', color: '#0f172a', backgroundColor: '#ffffff' }}>
                {reportData?.qualitative?.appreciations_improvements || "None"}
              </td>
            </tr>
            <tr><td colSpan="5" style={{height: '20px', border: 'none', backgroundColor: '#ffffff'}}></td></tr>
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="5" className="text-center py-2 font-weight-bold" style={{ color: '#0f172a' }}>
                {getSystemSettings(generalSettings, "print_bill_footer")}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
});

export default RcrReportTemplate;
